import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const updateDashboardGuideStatus = () => {
  return axiosPrivate.post(`/dashboard/api/v1/dashboard-tour/`);
};